export default {
  tab: {
    dashboard: 'Scheduled Tasks Dashboard',
    detail: 'Scheduled Tasks Detail',
    index: 'Scheduler Tasks'
  },
  label: {
    jobSync: 'Job Integration',
    applicationSync: 'Application Integration',
    applicationPullSync: 'Pull Application Integration',
    employeePullSync: 'Employee Pull',
    applicationStatusPullSync: 'Pull Application Status Integration',
    applicationStatusPushSync: 'Push Application Status Integration',
    otherSync: 'Other Integration',
    company: 'Company Name',
    nextRunTime: 'Next Run Time',
    integrationType: 'Integration Type',
    lastSyncStatus: 'Last Sync Status',
    option: 'Action',
    onOff: 'On/Off',
    viewDetail: 'View Detail',
    startTime: 'Start Time',
    endTime: 'End Time',
    executeStatus: 'Execute Status',
    duration: 'Duration',
    exception: 'Error Summary',
    openJobCount: 'Open Job Count',
    newJobCount: 'New Job Count',
    closeJobCount: 'Close Job Count',
    successApplicationCount: 'Success Application Count',
    failApplicationCount: 'Fail Application Count',
    pendingApplicationCount: 'Pending Application Count',
    successCount: 'Success Count',
    failCount: 'Fail Count',
    scheduledTaskExecutorStatus: 'Scheduled Task Executor Status',
    executeHistory: 'Execute History',
    systemName: 'System Name',
    job: {
      new: 'New Job',
      open: 'Update Job',
      close: 'Close Job'
    },
    application: {
      success: 'Success',
      filed: 'Failed'
    },
    task: {
      total: 'Total',
      open: 'Open',
      close: 'Close',
      exception: 'Exception',
      current: 'Executing'
    },
    dayRange: {
      0: 'Today',
      7: '7 days',
      15: '15 days',
      30: '30 days'
    },
    errorRecordList: 'Error Record List',
    jobId: 'Job ID - ATS Job ID',
    jobName: 'Job Name',
    candidateId: 'Candidate ID',
    candidateEmail: 'Candidate Email',
    candidateName: 'Candidate Name',
    errorDate: 'Error Date',
    processStatus: 'Process Status',
    startDate: 'Start Date',
    endDate: 'End Date'
  },
  btn: {
    start: 'Start',
    pause: 'Pause',
    resume: 'Recover',
    viewDetail: 'View Detail',
    export: 'Export',
    viewErrorDetail: 'View Error Detail',
    markErrorHasProcessed: 'Mark Error Has Processed'
  },
  executeStatus: {
    Executed: 'Success',
    'Started execution': 'Start Execute',
    'Error!': 'Execute Error'
  },
  resumeStatus: {
    yes: 'Yes',
    no: 'No'
  },
  recordStatus: {
    update: 'Update',
    add: 'Add',
    delete: 'Close',
    success: 'Success',
    failed: 'Failed',
    pending: 'Pending'
  },
  dialog: {
    jobId: 'Job ID',
    jobName: 'Job Name',
    companyName: 'Company Name',
    atsJobId: 'ATS Job ID',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    option: 'Option',
    candidateId: 'Candidate ID',
    candidateEmail: 'Candidate Email',
    candidateName: 'Candidate Name',
    candidateStatus: 'Candidate Status',
    applyTime: 'Apply Time',
    isFinish: 'Is Finish',
    syncStatus: 'Sync Status',
    atsEmployeeId: 'ATS Employee ID',
    employeeId: 'Employee ID',
    employeeName: 'Employee Name',
    employeeEmail: 'Employee Email',
    fromCandidateStatus: 'From Candidate Status',
    toCandidateStatus: 'To Candidate Status',
    retry: 'Retry',
    syncErrorType: 'Error Type',
    syncErrorDetail: 'Error Detail'
  },
  placeholder: {
    keyword: 'Please input keyword',
    selectCompany: 'Please select company',
    selectType: 'Please select type',
    selectStatus: 'On/Off',
    selectProcessStatus: 'Please select process status'
  },
  message: {
    startConfirm: 'Are you sure to start the task?',
    pauseConfirm: 'Are you sure to pause the task?',
    resumeConfirm: 'Are you sure to recover the task?',
    removeConfirm: 'Are you sure to remove the task?',
    addConfirm: 'Are you sure to add the task?',
    retryTip: 'Click to add to next round sync list',
    retrySuccess: 'Retry success!',
    noErrorInfo: 'No error messages recorded!'
  },
  tips: {
    operateSuccess: 'Operation success! The task will be executed in one minute, please refresh the page later to check the status!'
  },
  ERROR_TYPE: {
    UNKNOWN_ERROR: 'Unknown Error',
    TASK_FINISHED_ERROR: 'Task Finished Error',
    USER_INVALID_ERROR: 'User Invalid Error',
    REQUEST_FAILED_ERROR: 'Request Failed Error',
    REQUEST_TIMEOUT_ERROR: 'Request Timeout Error',
    JOB_NOT_FOUND_ERROR: 'Job Not Found_Error',
    APPLICATION_SYNC_PHONE_VALIDATION_ERROR: 'Application Sync Phone Validation Error',
    APPLICATION_SYNC_CITY_VALIDATION_ERROR: 'Application Sync City Validation Error',
    APPLICATION_SYNC_SOURCE_VALIDATION_ERROR: 'Application Sync Source Validation Error',
    APPLICATION_SYNC_EMPLOYEE_ID_VALIDATION_ERROR: 'Application Sync Employee Id Validation Error',
    APPLICATION_SYNC_POSTAL_CODE_VALIDATION_ERROR: 'Application Sync Postal Code Validation Error',
    APPLICATION_SYNC_EMAIL_EMPTY_ERROR: 'Application Sync Email Empty Error',
    APPLICATION_STATUS_PULL_NOT_FOUND_ERROR: 'Application Status Pull Not Found Error',
    APPLICATION_SYNC_NOT_ALLOW_RECOMMEND_ERROR: 'Application Sync Not Allow Recommend Error',
    APPLICATION_STATUS_PULL_NOT_FOUND_STATUS_ERROR: 'Application Status Pull Not Found Status Error',
    APPLICATION_STATUS_PUSH_NOT_FOUND_STATUS_ERROR: 'Application Status Push Not Found Status Error',
    APPLICATION_STATUS_PUSH_WORKFLOW_ERROR: 'Application Status Push Workflow Error',
    MSD_DISPOSITION_STAGE_NOT_FOUND_ERROR: 'MSD Disposition Stage Not Found Error',
    MSD_APPLICATION_STATUS_NOT_FOUND_ERROR: 'MSD Application Status Not Found Error',
    APPLICATION_STATUS_NO_UPDATE_ERROR: 'Application Status No Update Error',
    APPLICATION_HAS_EXIST_ERROR: 'Application Has Exist Error',
    CANDIDATE_CREATE_FAILED_ERROR: 'Candidate Create Failed Error',
    CANDIDATE_ID_MISSING_ERROR: 'Candidate Id Missing Error',
    CANDIDATE_SYNC_TIMEOUT_ERROR: 'Candidate Sync Timeout Error',
    CANDIDATE_NETWORK_ERROR: 'Candidate Network Error'
  },
  PROCESS_STATUS: {
    UNPROCESSED: 'Unprocessed',
    PROCESSED: 'Processed'
  }
}
